/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetServiceAgreementListRequest
 */
export interface GetServiceAgreementListRequest {
    /**
     * 
     * @type {string}
     * @memberof GetServiceAgreementListRequest
     */
    partnerUid?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceAgreementListRequest
     */
    businessRelationUid?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceAgreementListRequest
     */
    accountNumber?: string;
}

/**
 * Check if a given object implements the GetServiceAgreementListRequest interface.
 */
export function instanceOfGetServiceAgreementListRequest(value: object): value is GetServiceAgreementListRequest {
    return true;
}

export function GetServiceAgreementListRequestFromJSON(json: any): GetServiceAgreementListRequest {
    return GetServiceAgreementListRequestFromJSONTyped(json, false);
}

export function GetServiceAgreementListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceAgreementListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUid': json['partnerUid'] == null ? undefined : json['partnerUid'],
        'businessRelationUid': json['businessRelationUid'] == null ? undefined : json['businessRelationUid'],
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
    };
}

export function GetServiceAgreementListRequestToJSON(json: any): GetServiceAgreementListRequest {
    return GetServiceAgreementListRequestToJSONTyped(json, false);
}

export function GetServiceAgreementListRequestToJSONTyped(value?: GetServiceAgreementListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUid': value['partnerUid'],
        'businessRelationUid': value['businessRelationUid'],
        'accountNumber': value['accountNumber'],
    };
}

